import React from 'react';

class HiddenForm extends React.Component {
    render() {
        const {
            method, url, value, color = 'blue', fields, style = 'col-12 left-align dropdown-option', inline = false,
        } = this.props;

        const additionalFields = fields
            ? fields.map(({ name, value }) => <input key={name} type="hidden" name={name} value={value} />)
            : [];

        return (
            <form style={{ display: inline ? 'inline' : 'block' }} method="POST" action={url} acceptCharset="UTF-8">
                <input name="_token" type="hidden" value={window.csrfToken} />
                <input type="hidden" name="_method" value={method} />
                {additionalFields}
                <input className={`${color} ${style}`} type="submit" value={value} />
            </form>
        );
    }
}

export default HiddenForm;
